// dealer
export const REQUEST_DEALERS = '@main/REQUEST_DEALERS';
export const SET_LIST_DEALERS = '@main/SET_LIST_DEALERS';
export const FETCH_LIST_DEALERS = '@main/FETCH_LIST_DEALERS';
